/* eslint-disable no-console */

import { fetchUserEmailAddresses } from "@/store/userEmailAddresses/userEmailAddressActions";
import { toast, toastI18n } from "@/components/common/Toast";
import { fetchProjects } from "@/store/project/projectActions";
import { fetchChallengeData } from "@/store/projectProfile-v1/projectProfileActions";
import { updateProjectInvitationNotificationOnAccept } from "@/store/notifications/notificationActions";
import { REMOVE_EVENT_INVITATION } from "@/store/events-v1/eventConstants";
import { fetchNewAlerts } from "@/store/alerts/alertsAction";

import { fetchHubData } from "../hubs/hubActions";
import {
  doRedirect,
  BEGIN_REQUEST,
  FINISH_REQUEST,
  RESET_USER_INVITATIONS_LOADED,
  SET_USER_INVITATIONS_LOADED,
  RESET_SIGNUP,
} from "../metadata/metadataActions";
import { fetchProjectData } from "../projectData/projectDataActions";
import { request } from "@/utils/api/legacyRequest";
import { buildInvitationOutcomeEvent, track } from "@/analytics";
import { getAuthUser } from "../auth/authActions";
import { BACKEND_URI } from "@/config";

export const RESET_INVITATION_TOKEN = "invitations/RESET_INVITATION_TOKEN";

export const SET_CREATE_HUB_INVITATION =
  "invitations/SET_CREATE_HUB_INVITATIONS";
export const SET_CREATE_HUB_INVITATION_TOKEN =
  "invitations/SET_CREATE_HUB_INVITATION_TOKEN";
export const SET_HUB_EVENT_INVITATION_TOKEN =
  "invitations/SET_HUB_EVENT_INVITATION_TOKEN";
export const SET_HUB_INVITATION_TOKEN = "invitations/SET_HUB_INVITATION_TOKEN";

export const invitationTypes = {
  createHub: "createHub",
  hubEventInvitation: "hubEventInvitation",
  hubInvitation: "hubInvitation",
  projectInvitation: "projectInvitation",
};

/* ******************* */
/* PROJECT INVITATIONS */
/* ******************* */

export const SET_ACTIVE_PROJECT_INVITATIONS =
  "invitations/SET_ACTIVE_PROJECT_INVITATIONS";

export const RESET_ACTIVE_PROJECT_INVITATION_ON_DECLINE =
  "invitations/RESET_ACTIVE_PROJECT_INVITATION_ON_DECLINE";

export const SET_PROJECT_INVITATION_TOKEN =
  "invitations/SET_PROJECT_INVITATION_TOKEN";

export function fetchActiveProjectInvitations() {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/invitations/project-invitations`;
    return request(url, jwt).then((response) => {
      dispatch({ type: SET_ACTIVE_PROJECT_INVITATIONS, data: response.data });
      // dispatch(pendingInvitationPopup());
    });
  };
}

export const processProjectInvitationOnSuccess = (
  response,
  redirect,
  token
) => {
  return (dispatch, getState) => {
    const { user } = getState();
    dispatch(toast.hide());
    dispatch(fetchUserEmailAddresses());
    dispatch(toastI18n('success', 'ProjectInvitationAccepted'));
    dispatch({ type: RESET_INVITATION_TOKEN });
    dispatch(fetchProjects());
    dispatch(getAuthUser(user.get("id")));
    dispatch(fetchChallengeData());
    dispatch(fetchProjectData());
    const { appData } = getState();
    const { userProjectRoleTypes } = appData;
    const userRole = userProjectRoleTypes
      .toJS()
      .filter((role) => role.id === response.data.role_type_id);
    if (redirect) {
      if (userRole?.length && userRole[0].level > 30)
        dispatch(doRedirect(`/project/${response.data.project_id}/builders`));
      else dispatch(doRedirect(`/project/${response.data.project_id}`));
    }
    dispatch(updateProjectInvitationNotificationOnAccept(token));
    return "";
  };
};

/* ********************** */
/* CREATE HUB INVITATIONs */
/* ********************** */

export const createHubInvitationOnSuccess = (response) => (dispatch) => {
  dispatch({
    type: SET_CREATE_HUB_INVITATION,
    data: response.data,
  });
  dispatch(doRedirect("/create-hub/start"));
};

/* *************** */
/* HUB INVITATIONs */
/* *************** */

export const SET_HUB_INVITATIONS = "invitations/SET_HUB_INVITATIONS";
export function fetchHubInvitations() {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/invitations/hub-invitations`;
    return request(url, jwt).then((response) =>
      dispatch({ type: SET_HUB_INVITATIONS, data: response.data })
    );
  };
}

export const hubInvitationOnSuccess = (response, redirect, token) => {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    const { user } = getState();
    dispatch(toast.hide());
    dispatch(fetchUserEmailAddresses());
    if (redirect) dispatch(doRedirect(`/hubs/${response.data.hub_id}/welcome`));
    dispatch(toastI18n('success', 'InvitationAccepted'));
    dispatch({ type: SET_HUB_INVITATIONS, token });
    dispatch({ type: RESET_INVITATION_TOKEN });
    dispatch(fetchHubData());
    dispatch(fetchHubInvitations());
    dispatch(getAuthUser(user.get("id")));
    return "";
  };
};

export const DELETE_PENDING_HUB_EVENT_INVITATION =
  "invitations/DELETE_PENDING_HUB_EVENT_INVITATION";
export function deleteHubEventInvitation(eventId, invitationId) {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/events/${eventId}/invitations/${invitationId}`;

    const { user } = getState();

    const jwt = user.get("jwt");

    request(url, jwt, "DELETE")
      .then(() => {
        dispatch({ type: DELETE_PENDING_HUB_EVENT_INVITATION, invitationId });
        dispatch({ type: REMOVE_EVENT_INVITATION, data: invitationId });
        dispatch(toastI18n('success', 'InvitationDeleted'));
      })
      .catch((err) => console.error(err));
  };
}

export function resendHubEventInvitation(eventId, invitationId) {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    const { user } = getState();

    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/events/${eventId}/invitations`;

    const payload = {
      resend_invitation: {
        event_invitation_id: invitationId,
      },
    };

    request(url, jwt, "POST", payload)
      .then(() => {
        dispatch(toastI18n('success', 'InvitationResent'));
      })
      .catch((err) => console.error(err));
  };
}

export const SET_USER_HUB_EVENT_INVITATIONS =
  "invitations/SET_USER_HUB_EVENT_INVITATIONS";
export function fetchHubEventInvitations() {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/invitations/hub-event-invitations`;
    return request(url, jwt).then((response) =>
      dispatch({ type: SET_USER_HUB_EVENT_INVITATIONS, data: response.data })
    );
  };
}

export const hubEventInvitationOnSuccess =
  (response) => (dispatch, getState) => {
    dispatch(toast.hide());
    dispatch(fetchUserEmailAddresses());
    dispatch(toastI18n('success', 'InvitationAccepted'));
    dispatch({ type: RESET_INVITATION_TOKEN });
    dispatch(fetchHubData());
    dispatch(fetchHubEventInvitations());

    // if the user is a participant, take them to the select project modal
    const { appData } = getState();
    const role = appData.userEventRoleTypes.find(
      (uert) => uert.get("id") === response.data.user_event_role_type_id
    );
    switch (role.get("name")) {
      case "Competitor":
        dispatch(
          doRedirect(`/events/${response.data.hub_event_id}/select-project`)
        );
        break;
      case "Judge":
        dispatch(
          doRedirect(`/events/${response.data.hub_event_id}/welcome-judge`)
        );
        break;
      case "Resource":
        dispatch(
          doRedirect(`/events/${response.data.hub_event_id}/welcome-resource`)
        );
        break;
      default:
        dispatch(doRedirect(`/events/${response.data.hub_event_id}`));
    }
  };

/* ********************** */
/* PROCESS INVITATOINS    */
/* ********************** */

const processInvitationData = {
  [invitationTypes.createHub]: {
    setTokenAction: SET_CREATE_HUB_INVITATION_TOKEN,
    apiEndpoint: "api/v2/rebel/invitations/create-hub-invitations",
    onSuccess: createHubInvitationOnSuccess,
  },
  [invitationTypes.hubEventInvitation]: {
    setTokenAction: SET_HUB_EVENT_INVITATION_TOKEN,
    apiEndpoint: "api/v2/rebel/events/hub-event-invitations",
    payloadKey: "hub_event_invitation",
    onSuccess: hubEventInvitationOnSuccess,
  },
  [invitationTypes.hubInvitation]: {
    setTokenAction: SET_HUB_INVITATION_TOKEN,
    apiEndpoint: "api/v2/rebel/affiliations/hub-invitations",
    payloadKey: "hub_invitation",
    onSuccess: hubInvitationOnSuccess,
  },
  [invitationTypes.projectInvitation]: {
    setTokenAction: SET_PROJECT_INVITATION_TOKEN,
    apiEndpoint: "api/v2/rebel/project/invitations",
    payloadKey: "process_project_invitation",
    onSuccess: processProjectInvitationOnSuccess,
  },
};

// The analytics `invite_type` for each internal invitation type. Kept next to
// `processInvitationData` because the two are indexed by the same keys and drift
// between them would silently mislabel a quarter of the accept funnel.
const analyticsInviteType = {
  [invitationTypes.createHub]: "CreateHub",
  [invitationTypes.hubEventInvitation]: "HubEvent",
  [invitationTypes.hubInvitation]: "Hub",
  [invitationTypes.projectInvitation]: "Project",
};

// What the server says it granted, as opposed to what the invite card claimed.
// Only the hub and project flavours resolve to something this event can carry:
// a hub-event acceptance answers with `hub_event_id`, which is neither a hub nor
// a project id, and inventing one from it would be worse than recording none.
const grantedScope = (invitationType, response) => {
  const data = response?.data || {};
  if (invitationType === invitationTypes.hubInvitation) {
    return { hubId: data.hub_id ?? null, projectId: null };
  }
  if (invitationType === invitationTypes.projectInvitation) {
    return { hubId: null, projectId: data.project_id ?? null };
  }
  return { hubId: null, projectId: null };
};

// `invite_id` is null on every accept: the token flow is the only accept path,
// and a token carries no notification id. The invitations list fires
// `invitation_clicked` with the id immediately before dispatching into here, so
// the two join on session and time. Declines, which are notification-scoped,
// do carry it.
const trackAcceptOutcome = ({ invitationType, outcome, response, status, errorCode }) => {
  const { hubId, projectId } = outcome === "success"
    ? grantedScope(invitationType, response)
    : { hubId: null, projectId: null };

  track(
    buildInvitationOutcomeEvent({
      inviteType: analyticsInviteType[invitationType],
      action: "accept",
      outcome,
      statusCode: status ?? null,
      errorCode: errorCode ?? null,
      hubId,
      projectId,
    })
  );
};

const generatePayload = (invitationType, token) =>
  Object.defineProperty({}, processInvitationData[invitationType].payloadKey, {
    value: { token },
    enumerable: true,
  });

const invitationProcessOnSuccess = (
  response,
  invitationType,
  redirect,
  redirectTo,
  token,
  dispatch
) => {
  // A 403/422 arrives down the success path rather than as a thrown error, so
  // the outcome has to be decided here and not only in the catch below. This is
  // the branch where an invite is refused while the UI has, on the list flow,
  // already marked it accepted.
  if (response.status === 403 || response.status === 422) {
    trackAcceptOutcome({
      invitationType,
      outcome: "error",
      status: response.status,
      errorCode: response.status === 422 ? "expired_or_invalid" : "wrong_account",
    });
    dispatch(toastI18n('error', 'LoginWithCorrectEmail'));
    if (redirect) dispatch(doRedirect(redirectTo));
    return dispatch({ type: RESET_INVITATION_TOKEN });
  }
  trackAcceptOutcome({
    invitationType,
    outcome: "success",
    response,
    status: response.status ?? null,
  });
  if (invitationType === "createHub") dispatch(doRedirect(redirectTo));
  return dispatch(
    processInvitationData[invitationType].onSuccess(response, redirect, token)
  );
};

const invitationProcessOnError = (err, invitationType, redirect, redirectTo, dispatch) => {
  trackAcceptOutcome({
    invitationType,
    outcome: "error",
    status: err.status ?? null,
  });

  switch (err.status) {
    case 422:
      dispatch(toastI18n('error', 'InvitationExpired'));
      break;
    case 401:
    case 403:
      dispatch(toastI18n('error', 'LoginWithCorrectEmail'));
      break;
    default:
      dispatch(toastI18n('error', 'InvalidToken'));
      console.log(err.status);
  }
  if (redirect) {
    dispatch(doRedirect(redirectTo));
  }
};

export const processInvitationToken =
  (token, invitationType, redirect = true) =>
    async (dispatch, getState) => {
      if (!token) return;

      if (!Object.keys(invitationTypes).includes(invitationType)) return;

      const { user } = getState();
      if (invitationType === "createHub")
        dispatch({
          type: processInvitationData[invitationType].setTokenAction,
          token,
        });

      const jwt = user.get("jwt");
      const redirectTo = jwt ? `/profile/${user.get("id")}` : "/";
      if (!jwt) {
        // Not a failure of the invitation — the token is stashed and replayed
        // after login by `processInvitationTokens`. It is recorded because it
        // is where the funnel forks: everyone who arrives from an invite email
        // while logged out passes through here, and only some come back.
        trackAcceptOutcome({
          invitationType,
          outcome: "error",
          errorCode: "not_authenticated",
        });
        if (invitationType !== "createHub")
          dispatch({
            type: processInvitationData[invitationType].setTokenAction,
            token,
          });
        dispatch(toastI18n('warning', 'SignupOrLoginFirst'));
        dispatch(doRedirect("/auth/login"));
        return;
      }

      let url = `${BACKEND_URI}/${processInvitationData[invitationType].apiEndpoint
        }`;
      if (invitationType === "createHub") url = url.concat(`/${token}`);

      try {
        dispatch({ type: BEGIN_REQUEST });
        let response;
        if (invitationType === "createHub") response = await request(url, jwt);
        else {
          const payload = generatePayload(invitationType, token);
          response = await request(url, jwt, "POST", payload);
        }
        invitationProcessOnSuccess(
          response,
          invitationType,
          redirect,
          redirectTo,
          token,
          dispatch
        );
        dispatch(fetchNewAlerts(user.get("id")));
      } catch (err) {
        invitationProcessOnError(err, invitationType, redirect, redirectTo, dispatch);
      } finally {
        dispatch({ type: FINISH_REQUEST });
      }
    };

// Check token exist to process
export function isTokenAvailableToProcessInvitation(invitations) {
  const {
    hubEventInvitationToken,
    projectInvitationToken,
    createHubInvitationToken,
    hubInvitationToken,
  } = invitations;

  if (
    hubEventInvitationToken ||
    projectInvitationToken ||
    createHubInvitationToken ||
    hubInvitationToken
  )
    return true;
  return false;
}

// If there are any invitations, process them (accept) and
// redirect to the respective accepted invitation entity.
// If no tokens are present, go to way-find.
export function processInvitationTokens() {
  return (dispatch, getState) => {
    const { invitations } = getState();

    const {
      hubEventInvitationToken,
      projectInvitationToken,
      createHubInvitationToken,
      hubInvitationToken,
    } = invitations;

    if (hubEventInvitationToken) {
      return dispatch(
        processInvitationToken(
          hubEventInvitationToken,
          invitationTypes.hubEventInvitation,
          false
        )
      );
    }

    if (projectInvitationToken) {
      return dispatch(
        processInvitationToken(
          projectInvitationToken,
          invitationTypes.projectInvitation,
          true
        )
      );
    }

    if (createHubInvitationToken) {
      return dispatch(
        processInvitationToken(
          createHubInvitationToken,
          invitationTypes.createHub,
          true
        )
      );
    }

    if (hubInvitationToken) {
      return dispatch(
        processInvitationToken(
          hubInvitationToken,
          invitationTypes.hubInvitation,
          true
        )
      );
    }

    return null;
  };
}

const clearIfRedirectFromProtectedRoute = ({ from }) => {
  if (from === "protectedRoute") {
    sessionStorage.removeItem("scrollDetails");
  }
};

const checkForRedirect = () => {
  if (sessionStorage.getItem("scrollDetails")) {
    const sessionData = JSON.parse(sessionStorage.getItem("scrollDetails"));
    const { previousPath } = sessionData;
    clearIfRedirectFromProtectedRoute(sessionData);
    return previousPath;
  }
  return false;
};

export function fetchUserInvitations() {
  return (dispatch, getState) => {
    const { metadata, invitations } = getState();
    dispatch({ type: RESET_USER_INVITATIONS_LOADED });
    Promise.all([
      dispatch(fetchHubEventInvitations()),
      dispatch(fetchHubInvitations()),
      dispatch(fetchActiveProjectInvitations()),
    ]).then(() => {
      dispatch({ type: SET_USER_INVITATIONS_LOADED });
      if (!metadata.isSignup) {
        if (isTokenAvailableToProcessInvitation(invitations)) {
          dispatch(processInvitationTokens());
        }

        const redirectPath = checkForRedirect();

        if (redirectPath) {
          return dispatch(doRedirect(redirectPath));
        }
      }
      return "";
    });
  };
}

export const processInvitationsAfterSignUp = () => {
  return async (dispatch, getState) => {
    const { invitations } = getState();
    const redirect = checkForRedirect();
    if (isTokenAvailableToProcessInvitation(invitations))
      await dispatch(processInvitationTokens());
    else if (redirect) dispatch(doRedirect(redirect));
    return dispatch({ type: RESET_SIGNUP });
  };
};
